/* eslint-disable global-require */
import get from 'lodash/get';
import { GOOGLE_AD_WORDS_TV_MOUNT_SKU_ID_DEFAULT } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
import { getMappedQaFlowSku } from 'src/containers/AddSkuPage/QuestionsFlowPage/utils';

/**
 *
 * Dynamic lookup. Lets see the proof of usage here
 * Add ur sku paths here.
 * @type {{'38': *, '13': *, '1034': *}}
 */

const SKU = {
  '38': require('./38'),
  '13': require('./13'),
  [getMappedQaFlowSku({ skuId: GOOGLE_AD_WORDS_TV_MOUNT_SKU_ID_DEFAULT })]: require('./879'),
  '1034': require('./1034'),
};

export function getMatchingSkuData(skuId) {
  return get(SKU, skuId, { error: 'no sku data' });
}
